// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:20
import { Location_abstract } from './../abstract/SagaBase/Location_abstract';
export class Location extends Location_abstract {}
